import { ChangeDetectionStrategy, Component, ElementRef } from "@angular/core";
import { SmFormFieldBase } from "./sm-form-field-base.component";
import { SmFormService } from "../sm-form-service";
import { InfoLineState } from "@Shared/Components/sm-info-stack/sm-info-stack.component";

@Component({
    standalone: false,
    selector: 'sm-form-field-url',
    templateUrl: './sm-form-field-url.component.html',
    outputs: ['onValueChanged', 'onFocusChanged'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SmFormFieldUrlComponent extends SmFormFieldBase {

    constructor(protected service: SmFormService, protected element: ElementRef) {
        super(service, element);
    }

    public infoStackState: InfoLineState = 'ExternalLink';
}